import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, Input, LifeSaverForm
} from '..';
import { LifeDocumentIntroHeader } from '../../pages';

export default function SignupProfileScreen() {
  const navigate = useNavigate();
  
  const handleNext = useCallback(() => {
    navigate('/signup/plan');
  }, [ navigate ]);

  const handleSkip = useCallback(() => {
    navigate('/signup/plan');
  }, [ navigate ]);

  return (
    <div className="signup-profile-screen screen">
      <LifeDocumentIntroHeader
        icon="person" 
        title="Profile"
        description="Enter your profile information."
      />
      <LifeSaverForm icon="person" header="Profile">
        <Input id="first-name" label="First Name" />
        <Input id="last-name" label="Last Name" />
        <Input id="phone" label="Phone" />
        <ButtonBar
          handlePrimary={handleNext}
          primaryText="Continue"
          secondaryText="Skip"
          handleSecondary={handleSkip}
        />
      </LifeSaverForm>
    </div>
  );
}